export const styles = {
  navButton: (theme) => ({
    color: theme.palette.text.secondary,
    backgroundColor: theme.palette.background.paper,
    border: 1,
    borderColor: theme.palette.border.primary,
    boxShadow: theme.shadows[1],
    "&:hover": {
      backgroundColor: theme.palette.background.hover,
    },
  }),
}
